import { render, staticRenderFns } from "./SmallScreen.vue?vue&type=template&id=888b9eb4&scoped=true"
import script from "./SmallScreen.vue?vue&type=script&lang=js"
export * from "./SmallScreen.vue?vue&type=script&lang=js"
import style0 from "./SmallScreen.vue?vue&type=style&index=0&id=888b9eb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888b9eb4",
  null
  
)

export default component.exports